import Body from './Body';
import Footer from './Footer';
import Header from './Header';
import OnlineCall from './OnlineCall';
import Online from './Online';
import Profile from './Profile';
import RecentCall from './RecentCall';
import CallScreen from './CallScreen';
import Offline from './Offline';
import EventManager from './transport/EventManager';
import CallInbound from './CallInbound';
import DTMF from './DTMF';
import CallTag from './CallTag';
import CallInfo from './CallInfo';
import AddCall from './AddCall';
import AddNewCall from './AddNewCall';
import FAQ from './FAQ';
import ChatList from './ChatList';
import MessageList from './MessageList';
import OnlineScreen from './OnlineScreen';
import EndCallProfile from './EndCallProfile';
import EndCallAgentProfile from './EndCallAgentProfile';
import EndCallChangePwd from './EndCallChangePwd';
import CallBreak from './CallBreak';
import CallBreakSelect from './CallBreakSelect';
import CallDashboard from './CallDashboard';

export {
  Body,
  Footer,
  Header,
  OnlineCall,
  Online,
  Profile,
  RecentCall,
  CallScreen,
  EventManager,
  Offline,
  CallInbound,
  DTMF,
  CallTag,
  CallInfo,
  AddCall,
  AddNewCall,
  FAQ,
  ChatList,
  MessageList,
  OnlineScreen,
  EndCallProfile,
  EndCallAgentProfile,
  EndCallChangePwd,
  CallBreak,
  CallBreakSelect,
  CallDashboard,
};



// WEBPACK FOOTER //
// src/dialpad/components/layout/index.js